<template>
	<div class="top-contributors-container" v-if="topContributors.length && topProjects.length">
		<div class="title-container">
			<div class="title-wrapper">
				<div class="title">
					<span>{{$t('homePage.topContributors')}}</span>
					<Information>
						<div class="hint-read-more">
							<p class="margin-bottom">{{$t('homePage.topContributorsHint')}}</p>
							<a href="#" @click.prevent="openFaq" id="readMore">{{$t('homePage.readMore')}}</a>
						</div>
					</Information>
				</div>
				<div class="sub-title">{{$t('homePage.meetMostEngaged')}}</div>
			</div>
		</div>
		<div class="projects-and-contributors-container">
			<div class="contributors-container" ref="scrollContainer">
				<div class="contributor" @click="selectedContributor = index" v-for="(contributor, index) in topContributors" :class="selectedContributor === index ? 'selected' : ''">
					<div class="number">{{index + 1}}</div>
					<div class="names">
						<div class="name">{{contributor.fullName}}</div>
						<div class="email">{{contributor.email}}</div>
					</div>
				</div>
				<div class="explore-all-projects" @click="goToProjects">
					{{$t('homePage.exploreAllProjects')}}
					<img class="arrow" src="@/drc/assets/images/round-arrow-right.svg" alt="arrow-right" />
					<img class="arrow-hover" src="@/drc/assets/images/round-arrow-right-hover.svg" alt="arrow-right" />
				</div>
			</div>
			<div class="projects-container">
				<div class="single-project-container" v-for="(project, index) in topProjects[selectedContributor]" :key="index">
					<ProjectCard :project="project" :forceList="!isMobileDevice" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ProjectCard from "@/drc/components/ProjectCard.vue";
import buttonMixin from "@/drc/mixins/project-button-mixin";
import {PAGE_NAME} from "@/common/utils/constants";
import Information from "@/drc/components/Information";

export default {
	name: "TopContributors",
	components: {
		ProjectCard,
		Information
	},
	mixins: [buttonMixin],
	props: {
		topContributors: {
			type: Array,
			default: () => []
		},
		topProjects: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			selectedContributor: 0,
		}
	},
	methods:{
		openFaq() {
			const url = this.$router.resolve({path: '/resources', query: { questionId: 9 }, hash: '#faq-section'}).href;
			window.open(url, '_blank');
		},
		goToProjects() {
			this.$router.push({name: PAGE_NAME.search});
		},
		handleScrollWidth(event) {
			if(this.displayWidth <= 1024){
				event.preventDefault();
				this.$refs.scrollContainer.scrollLeft += event.deltaY;
			}
		},
	},
	beforeDestroy() {
		this.$refs.scrollContainer?.removeEventListener("wheel", this.handleScrollWidth);
	},
	mounted() {
		this.$refs.scrollContainer?.addEventListener("wheel", this.handleScrollWidth);
	},
}
</script>

<style scoped lang="scss">
@import '@/common/assets/css/_variables.scss';

.top-contributors-container {
	background: #F2F2F7;
	color: #001F33;
	padding: 0 6% 50px 6%;

	@media (max-width: $mobile) {
		padding-left: 15px;
		padding-right: 15px;
	}

	.title-container {
		width: 100%;
		height: 120px;
		display: flex;
		justify-content: center;

		.title-wrapper {
			max-width: 1440px;
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;

			.title {
				display: flex;
				flex-direction: row;
				gap: 12px;
				align-items: center;

				span {
					font-family: Tiempos Text, serif;
					font-weight: 600;
					font-size: 28px;
					line-height: 34px;
					letter-spacing: 0.36px;
					vertical-align: middle;
					color: #161616;
				}
			}

			.sub-title {
				font-family: Roboto, serif;
				font-weight: 400;
				font-size: 20px;
				line-height: 25px;
				letter-spacing: 0.38px;
				color: #8E8E93;
			}
		}
	}
	.projects-and-contributors-container {
		display: flex;
		justify-content: center;
		gap: 48px;

		.contributors-container {
			display: flex;
			flex-direction: column;
			max-width: 500px;
			width: 100%;
			gap: 16px;
			overflow-x: auto;
			overflow-y: hidden;
			scrollbar-width: none;

			.explore-all-projects {
				font-family: Roboto, serif;
				font-weight: 400;
				font-size: 20px;
				line-height: 25px;
				letter-spacing: 0.38px;
				color: #001F33;
				cursor: pointer;
				margin-top: 16px;
				min-width: 250px;

				.arrow {
					display: inline;
				}

				.arrow-hover {
					display: none;
				}

				&:hover {
					text-decoration: underline;

					.arrow-hover {
						display: inline;
					}

					.arrow {
						display: none;
					}
				}
			}

			.contributor {
				cursor: pointer;
				display: flex;
				gap: 8px;
				border-right: 4px solid #F2F2F7;
				//border-right: 4px solid white;

				.number {
					background: #FFB81C;
					color:#001F33;
					width: 48px;
					height: 48px;
					min-width: 48px;
					font-family: Tiempos Text, serif;
					font-weight: 400;
					font-size: 28px;
					line-height: 34px;
					letter-spacing: 0.36px;
					text-align: center;
					padding-top: 8px;
					clip-path: polygon(30% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 30%);
				}

				.names {
					width: 100%;
					word-break: break-word;

					.name {
						font-family: Roboto, serif;
						font-weight: 600;
						font-size: 20px;
						line-height: 25px;
						letter-spacing: 0.38px;
						color: #001F33;
					}

					.email {
						font-family: Roboto, serif;
						font-weight: 400;
						font-size: 17px;
						line-height: 22px;
						letter-spacing: 0;
						color: #636366;
					}
				}

				&.selected {
					border-right: 4px solid #FFB81C;
					padding-bottom: 0;

					.number {
						background: #001F33;
						color: #FFB81C;
					}
				}
			}

		}

		.projects-container {
			max-width: 900px;
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 20px;
			min-height: 356px;

			.single-project-container {
				//height: 168px;
				border: 1px solid #F2F2F7;
				//border: 1px solid #E5E5EA;

				&:hover {
					border: 1px solid #F2F2F7;
					//border: 1px solid white;
				}
			}

		}
	}
}

@media (max-width: $tablet) {
	.top-contributors-container {
		.projects-and-contributors-container {
			flex-direction: column;

			.projects-container {
				max-width: 100%;
			}

			.contributors-container {
				flex-direction: row;
				width: 100%;
				max-width: 100%;
				//overflow-y: scroll;

				.contributor {
					.names {
						word-break: keep-all;
					}

					&.selected {
						border-right: 4px solid #F2F2F7;
						border-bottom: 4px solid #FFB81C;
						padding-bottom: 8px;
					}
				}
			}
		}
	}
}

//@media (max-width: $mobile) {
//	.top-contributors-container {
//		.projects-and-contributors-container {
//			.projects-container {
//				.single-project-container {
//					height: 400px;
//				}
//			}
//		}
//	}
//}
</style>
